export const getWpData = () => window.IM_SEARCH_DATA || {};

export const getRestUrl = () => {
    const wpData = getWpData();
    return wpData.restUrl || '/wp-json/dom-ai/v1/';
};

export const getHeaders = (includeContentType = false) => {
    const wpData = getWpData();
    const headers = {
        'X-WP-Nonce': wpData.restNonce || '',
    };
    if (includeContentType) {
        headers['Content-Type'] = 'application/json';
    }
    return headers;
};

export const aiApi = {
    fetchSummary: async (searchQuery, resultIds) => {
        const response = await fetch(`${getRestUrl()}search/summary`, {
            method: 'POST',
            headers: getHeaders(true),
            body: JSON.stringify({
                query: searchQuery,
                resultIds: resultIds,
            }),
        });
        return response;
    },

    submitFeedback: async (conversationId, feedback) => {
        const response = await fetch(`${getRestUrl()}chat/feedback`, {
            method: 'POST',
            headers: getHeaders(true),
            body: JSON.stringify({
                conversationId: conversationId,
                feedback: feedback,
            }),
        });
        return response;
    },

    submitConsent: async (decline = false) => {
        const response = await fetch(`${getRestUrl()}consent`, {
            method: 'POST',
            headers: getHeaders(true),
            body: JSON.stringify({ decline }),
        });
        return response;
    }
};
